<template>
  <!-- 产业主体统计 -->
  <div id="dataScreening" style="width: 100%; max-width: 17.5vw; height: 14.5vw" :style="styleCls" v-show="productPie.length > 0"></div>
</template>
  <script>
import * as echarts from 'echarts';
export default {
  props: {
    productPie: [],
    seriesJson: {},
    styleCls: {
      height: '14.5vw'
    },
    itemGap: {
      type: Number | String,
      default: 20
    }
  },
  data() {
    return {
      myChart: null
    };
  },
  mounted() {
    console.log(this.productPie, 'productPie')
    var dataX = [];
    this.productPie.forEach(item => {
      item.value = item.data;
      dataX.push(item.name);
    });
    this.init(dataX);
  },
  watch: {},
  methods: {
    init(dataX) {
      const vw = 0.0525;
      const print = 'vw';
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('dataScreening'));
      const colorList = ['#1D5FD1', '#F6941E', '#01FFFF', '#1DD592', '#ee4a0a'];
      var list = this.productPie;
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: '-2%',
          top: 'center',
          itemGap: this.itemGap,
          selectedMode: false,
          itemWidth: 25,
          itemHeight: 10, // 设置图例标记的高度
          data: dataX,
          textStyle: {
            color: 'rgba(255,255,255,.6)',
            padding: [0, 2], //文字与图形之间的左右间距
            rich: {
              uname: {
                width: (this.seriesJson && this.seriesJson.richUnameWidth ? this.seriesJson.richUnameWidth : 65) * vw + print, // 65
                fontSize: 10 * vw + print
              },
              unum: {
                color: '#fff',
                width: 55 * vw + print,
                fontSize: 10 * vw + print,
                align: 'right'
              }
            }
          },
          formatter: function (name) {
            let arr = list.filter(item => {
              return item.name == name;
            });
            if (arr.length > 0) {
              if (arr[0].name == '养殖户') {
                return `{uname|${name}}{unum| ${arr[0].value || '0'} 户}`;
              } else {
                return `{uname|${name}}{unum| ${arr[0].value || '0'} 个}`;
              }
            } else {
              return `{uname|${name}}{unum| 0 个}`;
            }
          }
        },

        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            // center: ['22%', '50%'],
            center: this.seriesJson && this.seriesJson.seriesCenter ? this.seriesJson.seriesCenter : ['25%', '50%'], // ['25%', '50%']
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              // borderWidth: 3,
              // borderColor: '#fff' ['环境异常', '设备异常', '饲喂异常', '繁育数据异常']
            },
            color: colorList,
            data: list
          }
        ]
      };

      myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
#dataScreening {
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/views/businessModule/dataScreening.vue